<template>
<mu-container>
  <mu-breadcrumbs>
    <mu-breadcrumbs-item v-for="item in items" :key="item.text" :to="item.to" :disabled="item.disabled">{{item.text}}</mu-breadcrumbs-item>
  </mu-breadcrumbs>  
</mu-container>
</template>

<script>
export default {
  name: 'crumbs', 
  props: {
    items: {
      type:Array,
    },
    nid: {
      type: Number
    }
  },
  data () {
    return {
      navs:[]
    }
  },
  created: function() {
    // console.log(this.nid)
    // this.getNav()
  },
  watch: {
    $route(to, from) {
      // console.log(from)
      // if (!this.nid || this.nid != to.query.nid) {
      //   this.nid = to.query.nid
      // }
      // this.getNav()
		}
  },
  methods: {
    // getNav () {
    //   console.log(this.nid)
		// 	this.$get('/nav/get-nav-tree').then(res => {
		// 		if (res.code === 0) {
		// 			let data = res.data
		// 			console.log(data)
		// 			if (data){
		// 				this.navs = data
		// 			}
		// 		} else {
		// 			console.log(res.message)
		// 		}
		// 	})
		// }
  }
}
</script>

<style>
 .mu-breadcrumbs-item{
   color: #5e5e5e !important;
 }
</style>
